import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// All available translation namespaces for prefetching
const allNamespaces = [
  // Component namespaces
  'component/auth_layout',
  'component/before_delete_modal',
  'component/calendar',
  'component/checkbox_terms',
  'component/contract_applications',
  'component/dropdown',
  'component/footer_section',
  'component/have_trouble',
  'component/hours_range',
  'component/inappropriate_content_modal',
  'component/invited_recruiter_stepper',
  'component/invite_member',
  'component/links',
  'component/logout_modal',
  'component/lost_data_modal',
  'component/navigation_bar',
  'component/notes_modal',
  'component/not_found',
  'component/pagination_bar',
  'component/password_validation',
  'component/permanently_delete_modal',
  'component/personal_menu',
  'component/pricing_plans',
  'component/schedule_duration',
  'component/setup_layout',
  'component/snackbar',
  'component/table_toolbar',
  'component/timer_section',
  'component/upload_block',
  'component/waitlist_modal',
  // Page namespaces
  'page/agencies',
  'page/agency-invites',
  'page/agency_contracts',
  'page/agency_delete_steps',
  'page/agency_members',
  'page/agency_profile_settings',
  'page/agency_profile_setup',
  'page/analytics',
  'page/applications',
  'page/application_details',
  'page/contact_us',
  'page/contract',
  'page/contractors',
  'page/create_contract',
  'page/email-confirmation',
  'page/forgot-password',
  'page/inbox',
  'page/invite_members_setup',
  'page/manager_profile_setup',
  'page/personal-profile-settings',
  'page/personal-settings',
  'page/personal_profile_setup',
  'page/setup-recruiter',
  'page/sign-in',
  'page/sign-up-recruiter',
  'page/sign-up',
  'page/training_providers',
  'page/admin_analytics',
  'page/admin_feedback',
  'page/admin_feedback_details',
  'page/admin_contractors',
  'page/admin_contractor_details',
  'page/admin_resourcing_companies',
  'page/admin_resourcing_company_details',
  'page/admin_subscriptions',
  'page/agency-blocked',
  'page/agency_courses',
  'page/course_create',
  'page/course_page',
  'page/personal-notifications-settings',
  // Shared namespaces
  'shared/common',
  'shared/validation',
];

const translationVersion = crypto.randomUUID();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: 'languageOnly',
    debug: import.meta.env.NODE_ENV === 'dev',
    fallbackLng: 'en',
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?version=${translationVersion}`,
    },
    ns: allNamespaces,
    preload: ['en'],
    defaultNS: 'component/links',
    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
      nsMode: 'fallback',
    },
  });

export default i18n;
